import { CircuitBenefitType } from '@/types/circuits/CircuitBenefitType';

export const getAssociatedBenefitColumnType = (
  activityType?: string | null,
): Extract<CircuitBenefitType, 'Transport' | 'Activités'> =>
  activityType === 'TRANSFER' ? 'Transport' : 'Activités';
